export function registerVideoDirectives(Alpine) {
  // Alpine directive for auto play video
  Alpine.directive("autoplayvideo", (el) => {
    if (el.tagName === "VIDEO") {
      el.autoplay = true;
      el.muted = true;
      el.playsInline = true;
      el.loop = true;
      el.load();
      el.play().catch(() => {});
    }
  });
}
